// @flow
import { keyframes } from '@emotion/react'

export const cardUp = keyframes`
  from {transform: translateY(60px); opacity: 0;}
  to { transform: translateY(0); opacity: 1;}
`
